<app-fire-lightning-background [cssClass]="'v-centre'">
  <div class="center-panel">
    <div>
      <p>Loading..</p>
      <p>If you have not been redirected automatically please click <a [routerLink]="['/']">here</a>.</p>
    </div>
  </div>
</app-fire-lightning-background>
